import { useCallback, useEffect, useState } from 'react';
import type { SellerConnection } from '../../api/amazonconnect';
import { loadOpsIntelligence } from './loadOpsIntelligence';
import type { OpsIntelligenceModel } from './types';

export function useOpsIntelligence(opts: {
  refreshToken?: number;
  connection: SellerConnection | null;
}) {
  const { refreshToken = 0, connection } = opts;
  const [model, setModel] = useState<OpsIntelligenceModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const m = await loadOpsIntelligence({ connection });
      setModel(m);
      if (m.error) setError(m.error);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load Operations Intelligence');
      setModel(null);
    } finally {
      setLoading(false);
    }
  }, [connection]);

  useEffect(() => {
    void reload();
  }, [reload, refreshToken]);

  return { model, loading, error, reload };
}
